import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {

    obterErroComprometimentoEntrega(entregaId) {
        return axiosJwt.get(`${api}/credenciados/uabs/movimentos/entrega/${entregaId}/erro`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterErroComprometimentoDespViagem(codContracao, tipo) {
        return axiosJwt.get(`${api}/credenciados/uabs/movimentos/despviagem/${codContracao}/${tipo}/erro`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoEntrega(entregaId) {
        return axiosJwt.patch(`${api}/credenciados/uabs/movimentos/entrega/${entregaId}/excluir`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoDespViagem(codContracao, tipo) {
        return axiosJwt.patch(`${api}/credenciados/uabs/movimentos/despviagem/${codContracao}/${tipo}/excluir`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
